<template>
    <div>
        <Modal
            :show="shown"
            :title="this.$t('reports.saveModalTitle')"
            :close-callback="cancel"
            style-class="modal-report"
            class="for-unknown-height"
            :with-scroll="true"
            @close="cancel"
        >
            <form>
                <div class="wrapper input-with-insidelabel" :class="{ tooltiperror: $v.reportName.$invalid }">
                    <span v-if="$v.reportName.$invalid" class="tooltiptext">{{
                        errorDisplay($v.reportName, { val: MAX_REPORT_NAME_LENGTH })
                    }}</span>
                    <input
                        id="listenIn"
                        v-model="reportName"
                        v-focus
                        autocomplete="off"
                        @keydown.enter.prevent="save"
                    />
                    <label for="listenIn">{{ $t('common.name') }}</label>
                </div>
                <Scheduler
                    v-if="reportType !== REPORT_TYPES.ASCOM_EVENT"
                    :schedule="schedule"
                    @update="updateField"
                />
                <span v-else class="bold-text">{{ $t('reports.scheduleNotCreated') }}</span>
            </form>
            <div slot="footer">
                <div class="pull-right">
                    <button class="btn btn-ok" :disabled="isFormInvalid" @click="save">
                        {{ $t('common.save') }}
                    </button>
                    <button class="btn btn-cancel" @click="cancel">{{ $t('common.cancel') }}</button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script type="text/babel">
import Modal from './../common/Modal.vue';
import SelectBox from './../common/SelectBox.vue';
import Multiselect from 'moxa-vue-multiselect';
import Scheduler from './Scheduler.vue';
import { minimumLength, maximumReportNameLength, forbiddenNames, errorDisplay } from '../../validators';
import { REPORT_TYPES, MAX_REPORT_NAME_LENGTH } from '../../constants';
import commonDirectives from '../common/commonDirectives';
import { mapState } from 'vuex';

export default {
    components: {
        Modal,
        Multiselect,
        SelectBox,
        Scheduler,
    },

    directives: {
        focus: {
            // When the bound element is inserted into the DOM...
            inserted: function(el) {
                // Focus the element
                el.focus();
            },
        },
    },

    mixins: [commonDirectives],

    constants: {
        MAX_REPORT_NAME_LENGTH,
        REPORT_TYPES,
    },

    props: {
        shown: {
            type: Boolean,
            default: false,
        },

        existedReports: {
            type: Array,
            required: true,
        },

        defaultReportName: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            reportName: this.defaultReportName,
            isChanged: false,
            scheduleValid: true,
            schedule: {
                scheduled: false,
                scheduleType: 7,
                scheduleEmails: [],
                scheduleDescription: this.$t('reports.defaultReportEmailText', { reportName: '' }),
                emailingTime: '00:00',
            },
        };
    },

    validations() {
        return {
            reportName: {
                minimumLength,
                maximumReportNameLength,
                forbiddenNames: (val, rule) => {
                    rule = this.existedReports;
                    return forbiddenNames(val, rule);
                },
            },

            scheduleValid: {
                isTrue: val => val || this.reportType === REPORT_TYPES.ASCOM_EVENT,
            },
        };
    },

    computed: {
        ...mapState({ defaultRecipients: state => state.defaultRecipients }),
        /**
         * Checks whether or not form for saving is valid
         * @returns {boolean}
         */
        isFormInvalid() {
            return this.$v.reportName.$invalid || this.$v.scheduleValid.$invalid;
        },

        reportType() {
            return Number(this.$route.query.type);
        },
    },

    watch: {
        reportName() {
            this.isChanged = true;
        },
        shown() {
            this.reportName = this.defaultReportName;
        },
    },

    methods: {
        errorDisplay,

        /**
         * Emits events for report saving and closing save modal window
         */
        save() {
            if (!this.isFormInvalid) {
                let report = this.prepareReport(this.reportName, this.schedule);
                this.$emit('save', report);
                this.cleanForm();
                this.isChanged = false;
                this.$emit('close');
            }
        },

        /**
         * Emits event for closing save modal window
         */
        cancel() {
            this.cleanForm();
            this.isChanged = false;
            this.$emit('close');
        },

        cleanForm() {
            this.reportName = '';
            this.scheduleValid = true;
            this.schedule = {
                emailingTime: '00:00',
                scheduled: false,
                scheduleType: 7,
                scheduleEmails: this.defaultRecipients,
                scheduleDescription: this.$t('reports.defaultReportEmailText', { reportName: '' }),
            };
        },

        prepareReport(reportName, schedule) {
            return {
                reportName,
                scheduleEmails: schedule.scheduled ? schedule.scheduleEmails : [],
                scheduleType: schedule.scheduled ? schedule.scheduleType : null,
                emailingTime: schedule.scheduled ? schedule.emailingTime : '00:00',
                scheduleDescription: schedule.scheduled ? schedule.scheduleDescription : null,
            };
        },

        updateField(value) {
            if (value.field === 'schedule') {
                this.schedule = value.value;
            } else {
                this.schedule[value.field] = value.value;
                if (value.field === 'scheduled' && !!value.value) {
                    this.schedule.scheduleDescription = this.$t('reports.defaultReportEmailText', {
                        reportName: this.reportName,
                    });
                }
            }
            this.scheduleValid = value.valid;
        },
    },
};
</script>
